// tank types components
const TankTypes = () => import("Modules/configuration/tank_types/views/TankTypes");

export default {
    children: [
        {
            path: "configuration/tank_types",
            name: "tank_types",
            component: TankTypes,
            meta: {
                requiresAuth: true,
                title: "lang.tank_types",
                restrict_by_login_type: ["employee", "customer_support", "administrator", "developer"],
                restrict_by_permission: ["configuration.read"],
            },
        },
    ],
};
